import { createSlice } from "@reduxjs/toolkit";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    list: [],
    dashboardUpdated: false,
  },
  reducers: {
    setDashboards(state, action) {
      state.list = action.payload;
    },
    markDashboardUpdated(state) {
      state.dashboardUpdated = !state.dashboardUpdated; // toggle flag
    },
  },
});

export const { setDashboards, markDashboardUpdated } = dashboardSlice.actions;
export default dashboardSlice.reducer;
